export const validateUserDetails = (userdetails) =>{
    /*if(userdetails.userName === "" || userdetails.userName === null){
        return 'User Name cannot be empty';
    }
    else if(userdetails.userName.indexOf(' ') !== -1){
        return 'Spaces not allowed in userName';
    }*/

    let isValidCheckMsg=isValid(userdetails);
    if(isValidCheckMsg)
        return isValidCheckMsg;
    
    if(!userdetails.firstName){
        return 'First Name cannot be empty';
    }
    if(!userdetails.lastName || userdetails.lastName === 'Select gender'){
        return 'Last Name cannot be empty';
    }
    if(!userdetails.email){
        return 'Email Id required';
    }
    else if(!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+[\.[A-Z]{2,4}]?$/i.test(userdetails.email)){
        return 'Invalid email address';
    }

    if(!userdetails.contactNo){
        return 'Contact No. is required';
    }
    else if(isNaN(Number(userdetails.contactNo))){
        return 'Contact No. must be a number';
    }

    if(!userdetails.permissionType){
        return 'Please select permission type';
    }

    return '';
}

const isValid=(userdetails)=>
{
    for (let key in userdetails) {
        let value=userdetails[key];
        if(typeof value=='string')
        {
            let res= !value||value.match(/^[^<>!$%^?*~`{}=]*$/) ? null :'Please enter valid Input';
            if(res)
            {
                return res;
            }
        }
    }
    
    return null;
    
}